import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Slide, ToastContainer } from 'react-toastify';
import './index.css';
import Router from './routes/Router';
import { persistor, store } from './redux/store';
import i18n from './locales/i18n';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Router />
          <ToastContainer
            position="top-center"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Slide}
            className="mx-auto w-full text-secondary-50"
            toastStyle={{ color: 'white' }}
            toastClassName="bg-primary-900 text-secondary-50 mx-auto rounded-3xl text-white font-semibold w-fit flex"
            bodyClassName="mx-auto text-secondary-50 font-white"
            progressClassName="invisible text-secondary-50"
          />
        </BrowserRouter>
      </PersistGate>
    </I18nextProvider>
  </Provider>,
);
